
import React, { useEffect, useState } from 'react'
import { SelectCheckBox } from '../../../assets/images/svg/selectCheckBox'
import { UnSelectCheckbox } from '../../../assets/images/svg/unSelectCheckbox'
import './style.scss'

const DrpList = ({
    list,
    setSelectedList,
    isShowOrder,
    selectedList,
    type,
    index,
    coupon,
    loadingProductPackages
}) => {

    const [isOpen, setOpen] = React.useState(false)
    const [listType, setListType] = React.useState([])
    const [selectedIndex, setSelectedIndex] = React.useState('')

    const wrapperRef = React.useRef(null)
    useOutsideAlerter(wrapperRef, setOpen)

    useEffect(() => {
        setListType(list[list?.findIndex(x => x?.productType === type)]?.products)
        setSelectedIndex(selectedList?.findIndex(x => x?.productType === type))


    }, [list])

    const changeList = (listItem) => {
        let temp = [...selectedList]
        if (temp[index]?.productIds?.some(x => x?.productId === listItem?.productId)) {
            temp[index].productIds = temp[index]?.productIds?.filter(x => x?.productId !== listItem?.productId)
        }
        else {
            temp[index]?.productIds?.push(listItem)
        }
        setSelectedList({ ...coupon, productLimitation: temp })
    }

    return (
        <div className='custom-drp-list' ref={wrapperRef}>
            {!loadingProductPackages && <div className='selected-displayer' onClick={() => {
                setOpen(!isOpen)
                setListType(list[list?.findIndex(x => x?.productType === type)]?.products)
            }}>
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" /></svg>
                </span>
                {selectedList[selectedIndex]?.productIds?.length > 0 && <label>{selectedList[selectedIndex]?.productIds?.map((selectItem, idx) => {
                    if (idx < 3) {
                        return (
                            <i key={idx}>
                                {selectItem?.productName?.split('(')[0]}{`${idx + 1 < selectedList?.length && idx !== 2 ? ',' : selectedList?.length > 3 ? 'و ...' : ''}`}
                            </i>
                        )
                    }
                }
                )}
                </label>
                }
                {selectedList[selectedIndex]?.productIds?.length === 0 && <label>
                    {type === 2 && ' انتخاب تلفن گویا'}
                    {type === 1 && ' انتخاب منشی مجازی '}
                    {type === 4 && ' انتخاب فکس '}
                    {type === 3 && ' انتخاب خط'}
                </label>}
            </div>}
            {
                loadingProductPackages &&
                <div className='table-loading-invoice'>
                    <div className="spinner-border" role="status" aria-hidden="true"></div>
                </div>
            }
            <ul className={isOpen ? 'opened' : ''}>
                {listType?.map((listItem, idx) =>
                    <li key={idx}
                        onClick={() => { changeList(listItem, idx) }}>
                        <div className='d-flex justify-content-between align-items-center'>
                            <div className='d-flex justify-content-start align-items-center'>
                                {selectedList[selectedIndex]?.productIds?.some(i => i?.productId === listItem?.productId) ? <SelectCheckBox /> :
                                    <UnSelectCheckbox />}
                                <span>{listItem?.productName}</span>
                            </div>
                        </div>
                    </li>
                )
                }

            </ul>
        </div>

    )
}

export default DrpList


function useOutsideAlerter(ref, setDisplay) {
    React.useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setDisplay(false)
            }
        }
        document.body.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.body.removeEventListener('mousedown', handleClickOutside)

        }
    }, [ref])
}
